import { instance as axios, setJwtToken } from "../../config/axiosInstance";

// ------------------------Get Faq List------------------
export const getFaqApi = async (data) => {
  const endPoint = `admin-faq/faq-list?${new URLSearchParams({
    ...data,
  }).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};

// ------------------------Add FAQ------------------
export const addFaqApi = async (data) => {
  const endPoint = `admin-faq/add-update-faq`;
  return await axios.post(endPoint, data, setJwtToken());
};

// -------------------------Delete Faq ------------
export const deleteFaqApi = async (id) => {
  const endPoint = `admin-faq/delete-faq?faqId=${id}`;
  return await axios.delete(endPoint, setJwtToken());
};
